import React from 'react'
import { useMetaStore } from '../store/MetaStore'

const ErrorView = () => {
  const errorMsg = useMetaStore((state) => state.errorMsg)
  return (
    <div style={{ padding: '20px', fontSize: '2em', textAlign: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>{errorMsg ? errorMsg : ''}</div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>Restart the session from the event link provided.</div>
    </div>
  )
}

export default ErrorView
